import { OverlayScrollbars } from 'overlayscrollbars';
import { throttle } from 'lodash-es';

/**
 * OverlayScrollbars를 초기화하는 함수
 */
export const initializeOverlayScrollbars = (contentsRef: HTMLElement): OverlayScrollbars | null => {
    if (!contentsRef) return null;
    return OverlayScrollbars(contentsRef, {
        scrollbars: { autoHide: 'leave', theme: 'os-theme-light' },
        overflow: { x: 'hidden', y: 'scroll' },
    });
};

/**
 * 답변 요소로 스크롤하는 함수
 */
export const scrollToAnswer = throttle((osInstance: OverlayScrollbars, targetElementId: string, ignoreAutoScroll: boolean = false, position: 'top' | 'middle' | 'bottom' = 'middle') => {
    if (!osInstance || ignoreAutoScroll) return;

    const answerElement = document.getElementById(targetElementId);
    if (!answerElement) return;

    const { viewport } = osInstance.elements();
    const viewportRect = viewport.getBoundingClientRect();
    const answerRect = answerElement.getBoundingClientRect();
    const scrollTop = viewport.scrollTop;

    const targetScrollPosition = (() => {
        switch (position) {
            case 'top':
                return answerRect.top - viewportRect.top + scrollTop;
            case 'middle':
                return answerRect.bottom - (viewportRect.top + viewportRect.height / 2) + scrollTop;
            case 'bottom':
                return answerRect.bottom - viewportRect.height + scrollTop;
            default:
                return 0;
        }
    })();

    viewport.scrollTo({ top: targetScrollPosition, behavior: 'smooth' });
}, 500);

/**
 * 렌더링이 완료될 때까지 기다리는 함수
 */
export const afterRender = (): Promise<void> =>
    new Promise<void>(resolve => {
        const callback = () => {
            requestAnimationFrame(() => {
                resolve();
            });
        };
        requestAnimationFrame(callback);
    });
